import { Component, Input, OnInit } from '@angular/core';
import { SbModalState } from '../modal-state.service';
import { DatePickOptions, DatePickResult } from '../modal.model';
import { NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { NgbTranslatedDatepicker } from '../../../date-time/ngb-datepicker-translated.service';
import { DateTime } from 'luxon';

@Component({
  selector: 'sb-date-picker-modal',
  templateUrl: './sb-date-picker-modal.component.html',
  styleUrls: ['./sb-date-picker-modal.component.scss'],
  providers: [{ provide: NgbDatepickerI18n, useClass: NgbTranslatedDatepicker }],
  standalone: false,
})
export class SbDatePickerModalComponent implements OnInit {
  options: DatePickOptions<DatePickResult>;
  @Input()
  templateId: string;

  searchStr: string;

  initial: DatePickResult;

  change: boolean;

  get isSingle(): boolean {
    return !(this.isTime && this.isDate);
  }

  get isDate(): boolean {
    return this.options?.date ? true : false;
  }

  get isTime(): boolean {
    return this.options?.time ? true : false;
  }

  ngOnInit() {
    this.options = this.state.options.get(this.templateId) as DatePickOptions<DatePickResult>;
    this.initial = this.options.initial;
    if (!this.initial) {
      let mom = DateTime.local();
      this.initial = {
        time: {
          hour: 12,
          minute: 0,
          second: 0,
        },
        date: {
          year: +mom.year,
          month: +mom.month + 1,
          day: +mom.day,
        },
        cancel: false,
      };
    } else {
      this.refresh();
    }
    this.change = false;
  }

  constructor(private state: SbModalState) {}

  refresh() {
    if (this.initial.time) {
      this.initial.time = {
        hour: this.initial.time.hour,
        minute: this.initial.time.minute,
        second: this.initial.time.second,
      };
    }
    if (this.initial.date) {
      this.initial.date = {
        year: this.initial.date.year,
        month: this.initial.date.month,
        day: this.initial.date.day,
      };
    }
  }

  startOfDay() {
    this.initial.time.hour = 0;
    this.initial.time.minute = 0;
    this.initial.time.second = 0;
    this.refresh();
  }

  endOfDay() {
    this.initial.time.hour = 23;
    this.initial.time.minute = 59;
    this.initial.time.second = 59;
    this.refresh();
  }

  ok() {
    this.state.modals.get(this.templateId).close({
      date: this.initial.date,
      time: this.initial.time,
      cancel: false,
    });
  }

  checkOkEnabled() {
    return this.change;
  }

  onchange() {
    this.change = true;
  }

  cancel() {
    this.state.modals.get(this.templateId).close({
      value: null,
      cancel: true,
    });
  }
}
